import { defineStore } from 'pinia';

let types = {
    Images : [
        'image/png',
        'image/jpg',
        'image/jpeg'
    ],
    PDFs : [
        'application/pdf'
    ],
    Videos : [
        'video/mpeg-4'
    ]
};

const query = {
    search: {
        string: "",
        types: Object.keys(types)
    },
    category: [],
    position: [],
    keywords: [],
    communities: [],
    collections: [],
    floorplans: [],
    elevation: [],
    color_package: [],
    attached: null
  }

export const userMediaStore = defineStore('media', {
    state: () => {
        return {
            query: {...query},
            page: 1,
            limit: 24,
            selected: [],
            view_type: 'grid'
        }
    },
    getters: {
        hasFilters() {
            return JSON.stringify(this.query) != JSON.stringify(query)
        }
    },
    actions: {
        setPage(page) {
            if(typeof page == 'number') {
                this.page = page;
                return;
            }
            if(page == 'next') {
                this.page++;
            } else {
                this.page--;
            }
        },
        setLimit(limit) {
            this.limit = limit;
        },
        clear() {
            this.query = {...query}
        }
    }
})